import React, { useState } from 'react'
import BlogCard from '../../../components/BlogCard'
import DefaultButton from '../../../components/DefaultButton'

export default function BlogListingHead({ breadcrumbData, allData }) {

  const [visibleCount, setVisibleCount] = useState(6);
  const [isLoadMore, setIsLoadMore] = useState(true);
  const handleLoadMore = () => {
    if (isLoadMore) {
      setVisibleCount(prevCount => Math.min(prevCount + 3, allData.length));
      if (visibleCount + 3 >= allData.length) {
        setIsLoadMore(false); 
      }
    } else {
      setVisibleCount(6);
      setIsLoadMore(true); 
    }
  };

  return (
    <>
      <section className="press-release-listing">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-xl-6">
              <h1 className='heading'> Blogs That <span>Change Perspectives</span></h1>
            </div>
          </div>
          <div className="row">
            <BlogCard allData={allData} visibleCount={visibleCount} btnText="Read More" isBlogList />
          </div>
          <div className="col-lg-12">
            <div className='bloglist-headbtn'>
              <DefaultButton onClick={handleLoadMore} text={isLoadMore ? "Load more" : "Load Less"} color />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
